// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wawa","content":"styles_content__30Kg4"};